import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Component } from 'react';
import { getLocalText } from '@/utilities/language';
import { getRealShowOption } from '@/utilities/quest';
import { randomArray } from '@/utilities/common';

// const randomComp = () => Math.random() - 0.5;
// function randomOptions(options) {
//   const saveNoRandomOptions = [];
//   for (let i = options.length - 1; i >= 0; i--) {
//     const option = options[i];
//     if (option.noRandom) {
//       saveNoRandomOptions.push([option, i]);
//       options.splice(i, 1);
//     }
//   }
//   const result = options.slice().sort(randomComp);
//   while (saveNoRandomOptions.length) {
//     const [option, index] = saveNoRandomOptions.pop();
//     result.splice(index, 0, option);
//   }
//   return result;
// }
var Sort = /*#__PURE__*/function (_Component) {
  _inherits(Sort, _Component);
  function Sort(props) {
    var _this;
    _classCallCheck(this, Sort);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Sort).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setSelected", function (selected) {
      var _this$props$form$getF = _this.props.form.getFieldProps(_this.props.question.id, {
          initialValue: _this.props.answer
        }),
        onChange = _this$props$form$getF.onChange,
        formAnswer = _this$props$form$getF.value;
      onChange(_this.getSelectedChange(selected, formAnswer));
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function (optionId) {
      var clickedOptions = _toConsumableArray(_this.state.clickedOptions);
      var selected = _this.props.answer.selected.slice();
      // 之前的位置
      var oldIndex = selected.findIndex(function (el) {
        return el === optionId;
      });
      // 从之前的位置取出
      selected.splice(oldIndex, 1);
      // 如果已经排序 就丢到最后去 并从clickedOptions中去除
      if (clickedOptions.includes(optionId)) {
        selected.push(optionId);
        clickedOptions = clickedOptions.filter(function (id) {
          return id !== optionId;
        });
      } else {
        // 新排序的option 放到selected的对应位置 放到clickedOptions最后
        selected.splice(clickedOptions.length, 0, optionId);
        clickedOptions.push(optionId);
      }
      // 新的realShowOptions排序
      var options = [];
      var realShowOptions = _this.state.realShowOptions;
      selected.forEach(function (el) {
        options.push(realShowOptions.find(function (item) {
          return item.id === el;
        }));
      });
      _this.setState({
        clickedOptions: clickedOptions,
        realShowOptions: options
      });
      clearTimeout(_this.task);
      _this.task = setTimeout(function () {
        _this.setSelected(selected);
      }, 300);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleDragStart", function (sourceId) {
      _this.setState({
        sourceId: sourceId
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleDrop", function (targetId) {
      // ev.preventDefault();
      var selected = _this.props.answer.selected.slice();
      var sourceId = _this.state.sourceId;
      if (!sourceId) {
        return;
      }
      var sourceIndex = selected.findIndex(function (el) {
        return el === sourceId;
      });
      var targetIndex = selected.findIndex(function (el) {
        return el === targetId;
      });
      if (sourceIndex === targetIndex) return;
      if (sourceIndex < targetIndex) {
        selected.splice(targetIndex + 1, 0, sourceId);
        selected.splice(sourceIndex, 1);
      } else {
        selected.splice(sourceIndex, 1);
        selected.splice(targetIndex, 0, sourceId);
      }
      var options = [];
      var realShowOptions = _this.state.realShowOptions;
      selected.forEach(function (el) {
        options.push(realShowOptions.find(function (item) {
          return item.id === el;
        }));
      });
      _this.setState({
        realShowOptions: options
      });
      clearTimeout(_this.task);
      _this.task = setTimeout(function () {
        _this.setSelected(selected);
      }, 300);
    });
    var question = props.question,
      answers = props.answers;
    var _realShowOptions = getRealShowOption({
      question: question,
      answers: answers
    });
    _this.state = {
      errorOption: '',
      realShowOptions: _realShowOptions,
      sourceId: '',
      // 拖拽用
      clickedOptions: []
    };
    if (question.custom.random) {
      // 随机排序
      _this.state.realShowOptions = randomArray(_realShowOptions);
    } else if (question.custom.reverse) {
      var actuallyReverse = Math.random() >= 0.5;
      if (actuallyReverse) {
        _this.state.realShowOptions = randomArray(_toConsumableArray(_realShowOptions), 'reverse');
      }
    }
    _this.task = 0;
    return _this;
  }
  _createClass(Sort, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var options = this.state.realShowOptions.map(function (el) {
        return el.id;
      });
      var answer = this.props.answer;
      if (answer && answer.selected && answer.selected.length) {
        this.setSelected(answer.selected);
        var orderRealShowOptions = [];
        var realShowOptions = this.state.realShowOptions;
        answer.selected.forEach(function (id) {
          var option = realShowOptions.find(function (el) {
            return el.id === id;
          });
          if (option) {
            orderRealShowOptions.push(option);
          }
        });
        this.setState({
          realShowOptions: orderRealShowOptions
        });
        return;
      }
      this.setSelected(options);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var prevQ = prevProps.question;
      var nextQ = this.props.question;

      // 如果选项变了 就改变答案
      if (prevState.realShowOptions !== this.state.realShowOptions) {
        this.setSelected(this.state.realShowOptions.map(function (el) {
          return el.id;
        }));
      }

      // 预览模式下面始终不成立（broadcastchannel 使用JSON.stringify传递数据
      // 问卷模式下面始终成立， 问卷结构不会改变
      if (prevQ === nextQ) return;
      // 打开随机按钮
      if (!prevQ.custom.random && nextQ.custom.random) {
        // eslint-disable-next-line
        this.setState({
          realShowOptions: randomArray(_toConsumableArray(nextQ.custom.options))
        });
      }
      // 关闭随机按钮
      if (prevQ.custom.random && !nextQ.custom.random) {
        // eslint-disable-next-line
        this.setState({
          realShowOptions: nextQ.custom.options
        });
      }
      // 判断是否修改了options， 但是broadcastchannell始终是深拷贝传递。所以这里不能比较地址了。
      if (JSON.stringify(nextQ.custom.options) !== JSON.stringify(prevQ.custom.options)) {
        // eslint-disable-next-line
        if (nextQ.custom.random) this.setState({
          options: randomArray(_toConsumableArray(nextQ.custom.options))
        });
        // eslint-disable-next-line
        else this.setState({
          realShowOptions: nextQ.custom.options
        });
      }
    }
  }, {
    key: "getSelectedChange",
    value: function getSelectedChange(selected, answer) {
      var text = answer && answer.text || '';
      var _answer$option_blank = answer.option_blank,
        option_blank = _answer$option_blank === void 0 ? {} : _answer$option_blank;
      var _arr = Object.keys(option_blank);
      for (var _i = 0; _i < _arr.length; _i++) {
        var key = _arr[_i];
        if (!selected.includes(key)) {
          delete option_blank[key];
        }
      }
      return {
        type: 'sort',
        selected: selected,
        text: text,
        option_blank: option_blank
      };
    }
  }, {
    key: "getInputChange",
    value: function getInputChange(id, input, answer) {
      var text = answer && answer.text || '';
      var selected = (answer.selected || []).slice();
      if (!selected.includes(id)) {
        selected.push(id);
      }
      var _answer$option_blank2 = answer.option_blank,
        option_blank = _answer$option_blank2 === void 0 ? {} : _answer$option_blank2;
      return {
        type: 'sort',
        text: text,
        selected: selected,
        option_blank: _objectSpread({}, option_blank, _defineProperty({}, id, [input]))
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        question = _this$props.question,
        answer = _this$props.answer;
      var _this$state = this.state,
        realShowOptions = _this$state.realShowOptions,
        clickedOptions = _this$state.clickedOptions;
      var _this$props$form = this.props.form,
        getFieldProps = _this$props$form.getFieldProps,
        getFieldError = _this$props$form.getFieldError;
      var id = question.id || 'unknown-form-item';
      var _getFieldProps = getFieldProps(id, {
          initialValue: answer
        }),
        onChange = _getFieldProps.onChange,
        formAnswer = _getFieldProps.value; // 因为getFieldError无法判断error的来源，所以只能用这样的trick方法，
      // rc-form 写的真心不好
      var errorSelected;
      var errorText;
      var error = getFieldError(id);
      if (error && error[0] === getLocalText('SingleChoice.Selected')) {
        var _error = _slicedToArray(error, 1);
        errorSelected = _error[0];
      }
      if (error && error[0] === getLocalText('SingleChoice.otherText')) {
        var _error2 = _slicedToArray(error, 1);
        errorText = _error2[0];
      }
      var params = {
        options: realShowOptions,
        formAnswer: formAnswer,
        error: {
          selected: errorSelected,
          text: errorText,
          errorOption: this.state.errorOption
        },
        onChange: {
          selected: function selected(_selected) {
            return onChange(_this2.getSelectedChange(_selected, formAnswer));
          },
          input: function input(id, _input) {
            return onChange(_this2.getInputChange(id, _input, formAnswer));
          },
          click: function click(id) {
            return _this2.handleClick(id);
          }
        },
        handleDrop: this.handleDrop,
        handleDragStart: this.handleDragStart,
        clickedOptions: clickedOptions
      };
      return this.props.children(params);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      var question = nextProps.question,
        answers = nextProps.answers;
      var realShowOptions = getRealShowOption({
        question: question,
        answers: answers
      });
      window.allQuestions.find(function (el) {
        return el.id === question.id;
      }).custom.realShowOptions = realShowOptions;
      if (realShowOptions.length !== state.realShowOptions.length || realShowOptions.some(function (el) {
        return !state.realShowOptions.find(function (item) {
          return item.id === el.id;
        });
      }) || realShowOptions.some(function (el) {
        return el.text !== state.realShowOptions.find(function (item) {
          return item.id === el.id;
        }).text;
      })) {
        if (question.custom.random) {
          realShowOptions = randomArray(realShowOptions);
        }
        return {
          realShowOptions: realShowOptions
        };
      }
      return null;
    }
  }]);
  return Sort;
}(Component);
_defineProperty(Sort, "defaultProps", {
  answer: {
    selected: [],
    text: '',
    type: 'sort'
  }
});
export { Sort as default };